import { useEffect } from "react";

export default function useTailwindLoader() {
  useEffect(() => {
    // Carregar Tailwind CSS v4 apenas para esta página
    const tailwindScript = document.createElement('script');
    tailwindScript.src = 'https://cdn.tailwindcss.com';
    tailwindScript.id = 'tailwind-v4-script';

    // Verificar se já não foi carregado
    if (!document.getElementById('tailwind-v4-script')) {
      document.head.appendChild(tailwindScript);
    }

    // Carregar fontes Google Fonts
    const fontLink = document.createElement('link');
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800;900&display=swap';
    fontLink.rel = 'stylesheet';
    fontLink.id = 'raleway-font';

    if (!document.getElementById('raleway-font')) {
      document.head.appendChild(fontLink);
    }

    // Carregar fonte NeverMind Bauhaus local
    const bauhausStyle = document.createElement('style');
    bauhausStyle.id = 'bauhaus-font';
    bauhausStyle.textContent = `
      @font-face {
        font-family: 'NeverMindBauhaus';
        src: url('/assets/fonts/NeverMindBauhaus-Regular-BF6501284a7fde0.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'NeverMindBauhaus';
        src: url('/assets/fonts/NeverMindBauhaus-Medium-BF6501284a00903.ttf') format('truetype');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'NeverMindBauhaus';
        src: url('/assets/fonts/NeverMindBauhaus-DemiBold-BF6501284a86a43.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'NeverMindBauhaus';
        src: url('/assets/fonts/NeverMindBauhaus-Bold-BF6501284a8ae7b.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'NeverMindBauhaus';
        src: url('/assets/fonts/NeverMindBauhaus-Extrabold-BF6501284a9b844.ttf') format('truetype');
        font-weight: 800;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'NeverMindBauhaus';
        src: url('/assets/fonts/NeverMindBauhaus-Heavy-BF6501284aa018a.ttf') format('truetype');
        font-weight: 900;
        font-style: normal;
        font-display: swap;
      }
      .font-bauhaus {
        font-family: 'NeverMindBauhaus', 'Arial Black', sans-serif;
        font-weight: 700;
        letter-spacing: 0.02em;
      }
      .font-raleway {
        font-family: 'Raleway', sans-serif;
      }
    `;

    if (!document.getElementById('bauhaus-font')) {
      document.head.appendChild(bauhausStyle);
    }

    // Cleanup: remover os scripts e estilos quando o componente for desmontado
    return () => {
      const existingScript = document.getElementById('tailwind-v4-script');
      const existingFont = document.getElementById('raleway-font');
      const existingStyle = document.getElementById('bauhaus-font');

      if (existingScript) existingScript.remove();
      if (existingFont) existingFont.remove();
      if (existingStyle) existingStyle.remove();
    };
  }, []);
}
